
import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';
import { City } from '@/common/interface';

@Component
export default class CarLocationfield extends Vue {
  val = '';

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Prop()
  citys!: City[];

  @lazyInject(ShopService)
  shopService!: ShopService;

  @Prop()
  options!: Array<{ id: number; name: string; city: City[] }>;

  @Model('change', {
    type: String,
  })
  value!: string;

  @Watch('val')
  watchVal() {
    this.$emit('update', this.val);
  }

  @Watch('value')
  watchValue() {
    if (this.value) {
      // this.val = `${this.value}`;
    } else {
      this.val = '';
    }
  }

  onChange(val: string) {
    this.val = val;
  }


  mounted() {
    this.watchValue();
  }
}
